import Smartphones from 'Invoices/SupplierInvoices/views/SupplierInvoicesView/containers/Smartphones'
import Tablets from 'Invoices/SupplierInvoices/views/SupplierInvoicesView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const SupplierInvoicesView = getCurrentDeviceView(Smartphones, Tablets)

export default SupplierInvoicesView
